export default {
      id: "icon--chevron-usage",
      viewBox: "0 0 10 6",
      url: __webpack_public_path__ + "sprite.svg#icon--chevron",
      toString: function () {
        return this.url;
      }
    }